import dayjs from 'dayjs';
import { fireAndForget } from './async';
import { log } from './log';

interface Props {
  promises: () => Array<Promise<any>>;
  minimumElapsedMins: number;
}

/**
 * Promises that will run when the browser tab comes back into focus
 * if enough time (minimumElapsedMins) has passed since the last time
 * it was called.
 */

export const runOnFocus = ({ promises, minimumElapsedMins }: Props) => {
  // Setup auto feed fetch.
  let lastAutofeedFetch = dayjs();
  window.addEventListener('focus', () => {
    const nMinutesAgo = dayjs().subtract(minimumElapsedMins, 'minute');

    // If minimumElapsedMins mins have past since we last fetched, fetch again.
    const timeUntilNextFetch = lastAutofeedFetch.unix() - nMinutesAgo.unix();
    if (nMinutesAgo.unix() > lastAutofeedFetch.unix()) {
      log(`🛰 focus: Time expired. Running promises`);
      lastAutofeedFetch = dayjs();
      fireAndForget(promises());
    } else {
      log(`🕰 focus: seconds until next fetch = ${timeUntilNextFetch}`);
    }
  });
};
